import useUser from "../../users/hooks/useUser.ts";
import { useLocation } from "wouter";
import {
  DropdownMenuItem,
  DropdownMenuSeparator,
} from "@/components/ui/dropdown-menu";
import { MdOutlineCreditCard, MdOutlineShoppingCart } from "react-icons/md";
import { HiOutlineWrench } from "react-icons/hi2";
import { IoRecordingOutline, IoStatsChartOutline } from "react-icons/io5";
import { FaPhone, FaVenusDouble } from "react-icons/fa";

const MenuEntry = (props: { onClick: () => void; children: string }) => (
  <DropdownMenuItem onClick={props.onClick}>
    {props.children}
  </DropdownMenuItem>
);

const MainMenu = () => {
  const user = useUser();
  const [, navigate] = useLocation();
  return (
    <>
      
        {user && (user.tag === "doctor" || user.tag === "secretary") ? (
        <>
          <DropdownMenuItem onClick={() => navigate("/tasks")}><FaPhone /> Tâches</DropdownMenuItem>
          <DropdownMenuItem onClick={() => navigate("/quotes")}><IoStatsChartOutline /> Suivi des devis</DropdownMenuItem>
          <DropdownMenuItem onClick={() => window.open("/orders", "_blank")?.focus()}><MdOutlineShoppingCart /> Commandes</DropdownMenuItem>
          <DropdownMenuItem onClick={() => navigate("/checklists")}>Checklists de matériel</DropdownMenuItem>
          <DropdownMenuItem onClick={() => navigate("/respond")}><IoRecordingOutline /> Respond</DropdownMenuItem>
        </>
      ) : null}
      {user && user.tag === "doctor" ? (
        <>
      <DropdownMenuItem onClick={() => navigate("/tpe-payments")}>
        <MdOutlineCreditCard />
            Règlements TPE du jour
          </DropdownMenuItem>
          <DropdownMenuSeparator />
          <DropdownMenuItem onClick={() => navigate("/fusion")}>
            <FaVenusDouble />
            Fusionner patients doublons
          </DropdownMenuItem>
          <DropdownMenuItem onClick={() => navigate("/importedEmails")}>
            Emails importés
          </DropdownMenuItem>
          <DropdownMenuItem onClick={() => navigate("/pec-staging")}>
            PEC non rattachées
          </DropdownMenuItem>
          <DropdownMenuItem onClick={() => navigate("/stats")}><IoStatsChartOutline /> Statistiques</DropdownMenuItem>
          <DropdownMenuSeparator />
          <DropdownMenuItem onClick={() => navigate("/prefs")}>Préférences</DropdownMenuItem>
          <DropdownMenuItem onClick={() => navigate("/rules")}>
            Règles de l'agenda
          </DropdownMenuItem>
          <DropdownMenuItem onClick={() => navigate("/reminders")}>
            Rappels Sms/Mails
          </DropdownMenuItem>
          <DropdownMenuItem onClick={() => navigate("/horaires")}>Horaires</DropdownMenuItem>
          
          <DropdownMenuItem onClick={() => navigate("/therapeutic-choices-fees")}>
            Choix thérapeutiques et honoraires
          </DropdownMenuItem>
          <DropdownMenuItem onClick={() => navigate("/default-materials-by-act-kind")}>
            Matériaux par défaut
          </DropdownMenuItem>
          
          
          <DropdownMenuSeparator />
          <DropdownMenuItem onClick={() => navigate("/payroll-test")}>
            Fiche de paie
          </DropdownMenuItem>
          <DropdownMenuItem onClick={() => navigate("/secretary-contracts")}>
            Contrats secrétaires
          </DropdownMenuItem>
          
        </>
      ) : null}
      
      {user && user.username === "admin" ? (
        <>
        <DropdownMenuSeparator />
        <MenuEntry onClick={() => navigate("/users")}>Users</MenuEntry>
        </>
      ) : null}
      
      <DropdownMenuSeparator />
      <MenuEntry onClick={() => navigate("/logout")}>Se déconnecter</MenuEntry>
    </>
  );
};

export default MainMenu;
